import { useTranslation } from "react-i18next";
import { Collapsible, CollapsibleContent, CollapsibleTrigger, cn } from "@tellescope/ui";
import { ChevronDown, Eye } from "lucide-react";
import type { VisibilityCondition } from "../../../../../shared/schema/visibility";
import { ConditionBuilder } from "../../../ConditionBuilder";

interface VisibilitySectionProps {
  visibility: { condition: VisibilityCondition } | undefined;
  onChange: (condition: VisibilityCondition | undefined) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  label?: string;
  description?: string;
}

export function VisibilitySection({
  visibility,
  onChange,
  open,
  onOpenChange,
  label,
  description,
}: VisibilitySectionProps) {
  const { t } = useTranslation();

  return (
    <Collapsible open={open} onOpenChange={onOpenChange} className="border-t pt-4 mt-4">
      <CollapsibleTrigger className="flex items-center gap-2 w-full text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
        <ChevronDown className={cn("h-4 w-4 transition-transform", open && "rotate-180")} />
        <Eye className="h-4 w-4" />
        {label ?? t("Block Visibility Conditions")}
        {visibility && (
          <span className="text-xs bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded">{t("Conditional")}</span>
        )}
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-4">
        <p className="text-xs text-muted-foreground mb-3">
          {description ?? t("Set conditions to show or hide this block based on patient data.")}
        </p>
        <ConditionBuilder value={visibility?.condition} onChange={onChange} />
      </CollapsibleContent>
    </Collapsible>
  );
}
